import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientNameService {

  private clientNameSource = new BehaviorSubject<string>('')
  currentClientName$ = this.clientNameSource.asObservable(); 

  constructor() { }


  changeClientName(clientName: string) {
    this.clientNameSource.next(clientName);
  }
}
